<template>
  <a-layout style="padding-top: 65px;" class="center-container ">

    <a-layout-content class="center-div"
      :style="{ background: '#fff', padding: '24px', margin: 0, minHeight: '720px' }">

      <!-- 文档位置: 面包屑 -->
      <a-row>
        <a-breadcrumb separator=">" style="margin:0px 0px 20px 10px;">
          <!-- <a-breadcrumb-item>首页</a-breadcrumb-item> -->
          <a-breadcrumb-item>
            <router-link :to="'/admin/article'">
              文章管理
            </router-link>
          </a-breadcrumb-item>
          <a-breadcrumb-item>内容编辑</a-breadcrumb-item>
          <a-breadcrumb-item>{{ article.title }}</a-breadcrumb-item>
        </a-breadcrumb>
      </a-row>

      <!-- 文章节点&编辑器-->
      <a-row>
        <!--文档编辑器 -->
        <a-form :model="doc" layout="vertical" style="width: 100%;">
          <a-form-item>
            <a-button type="primary" @click="handleSave()">
              <CheckCircleOutlined /> 保存
            </a-button>
            <!-- 加载状态 -->
            &nbsp; &nbsp;<a-spin :spinning="loading" />
          </a-form-item>
          <a-form-item>
            <a-textarea v-model:value="doc.summary" placeholder="文章摘要" :allowClear="true"
              :auto-size="{ minRows: 2, maxRows: 5 }" />
          </a-form-item>
          <a-form-item>
            <a-button type="primary" @click="handlePreviewContent()">
              <EyeOutlined /> 内容预览
            </a-button>
          </a-form-item>
          <a-form-item>
            <div id="content"></div>
          </a-form-item>
        </a-form>
      </a-row>

      <!--预览抽屉框 -->
      <a-drawer width="900" placement="right" :closable="false" :visible="drawerVisible" @close="onDrawerClose">
        <div class="wangeditor" :innerHTML="previewHtml"></div>
      </a-drawer>

      <!-- 底部 -->
      <TheFooter></TheFooter>

    </a-layout-content>

  </a-layout>

</template>

<script lang="ts">
import { defineComponent, onMounted, ref, createVNode } from 'vue';
import axios from 'axios';
import { message, Modal } from 'ant-design-vue';
import { Tool } from "@/util/tool";
import { useRoute } from "vue-router";
import ExclamationCircleOutlined from "@ant-design/icons-vue/ExclamationCircleOutlined";
import store from "@/store"
import TheFooter from "@/components/the-footer.vue";

// 引入公共样式
//import '@/styles/mystyle.css'

/**
 * ！！！此版本 4.6.3
 * $ npm i wangeditor@4.6.3 --save
 */
import E from 'wangeditor'

// 引入highlight插件 highlight.min.js
// CDN方式引入需要申明变量
// declare let hljs: any;
import hljs from 'highlight.js'
import 'highlight.js/styles/xcode.css'


export default defineComponent({
  name: 'AdminDoc',
  components: {
    TheFooter
  },
  setup() {
    const route = useRoute();
    console.log("路由：", route);
    console.log("route.path:", route.path);          // /admin/doc
    console.log("route.query:", route.query);        // {"articleId": "2"}
    console.log("route.param:", route.params);       // {}
    console.log("route.fullPath:", route.fullPath);  // /admin/doc?articleId=2
    console.log("route.name:", route.name);          // AdminDoc
    console.log("route.meta:", route.meta);          // {loginRequire: true}

    // 文章ID
    const articleId = ref(route.query.articleId)
    const article: any = ref({})

    const param = ref();
    param.value = {};
    const loading = ref(false);

    // 查询文章详情
    // 文章管理 > 	Vue 入门教程  >  前端开发 / Vue
    const handQuery = () => {
      loading.value = true;
      axios.get("/article/detail/" + route.query.articleId).then((response) => {
        const result = response.data;
        if (result.code == 0 && result.message == 'success') {
          article.value = result.data;
          console.log("article ", article.value);
          // 修改doc内容
          if (article.value.content != undefined) {
            doc.value.content = article.value.content.content
            doc.value.id = article.value.content.id
          }
          doc.value.summary = article.value.summary

          // 修改富文本
          editor.txt.html(doc.value.content);
        } else {
          message.error(result.message);
        }
        loading.value = false;
      });

    };

    // ---------------- 表单 -----------------
    const doc = ref();
    doc.value = {
      articleId: route.query.articleId
    };

    const editor = new E('#content');
    editor.config.zIndex = 0;
    // 显示上传图片按钮，转成Base64存储，同时也支持拖拽图片
    editor.config.uploadImgShowBase64 = true;

    const handleSave = () => {
      loading.value = true;
      doc.value.content = editor.txt.html();
      console.log('save doc', doc.value)
      axios.post("/article/doc/save", doc.value).then((response) => {
        loading.value = false;
        const result = response.data; // data = commonResp
        if (result.code == 0 && result.message == 'success') {
          message.success("保存成功！");
        } else {
          message.error(result.message);
        }
      });
    };

    // ----------------富文本预览--------------
    const drawerVisible = ref(false);
    const previewHtml = ref();
    const handlePreviewContent = () => {
      const html = editor.txt.html();
      previewHtml.value = html;
      drawerVisible.value = true;
    };
    const onDrawerClose = () => {
      drawerVisible.value = false;
    };

    onMounted(() => {

      handQuery();

      console.log('user --> ', store.state.user)

      // 创建编辑器
      // 配置编辑器的高度
      editor.config.height = 720  // 单位为px
      // 挂载highlight插件 配置高亮插件
      // hljs.highlightAll()
      editor.highlight = hljs

      editor.create();

    });

    return {
      param,
      loading,
      doc,
      handleSave,

      drawerVisible,
      previewHtml,
      handlePreviewContent,
      onDrawerClose,
      articleId,
      article
    }
  }
});
</script>

<style scoped>
/* --------------------媒体查询,宽屏拉伸时保持居中显示--------------------------- */
/* 基础样式 */
.center-container {
  width: 100%;
}

/* 基础样式 */
.center-div {
  width: 100%;
}

/* 屏幕宽度大于或等于1475px时应用的样式 */
@media screen and (min-width: 1475px) {

  .center-container {
    display: flex;
    /* 水平居中 */
    justify-content: center;
    /* 垂直居中 */
    align-items: center;
    /* 父容器的高度设置为视窗高度 */
    /* 加上header高度 */
    height: 100vh + 70px;
  }

  .center-div {
    /* 或者具体的宽度值 */
    width: 1424px;
  }

}
</style>
